/* @jsx h */
import { defineComponent, h, onMounted } from "vue";
import { RouterView } from "vue-router";
import { Navbar, TopBar } from "@app/vue/components/index";

export const Layout = defineComponent({
  name: "Layout",
  setup() {
    onMounted(() => {});
    return () => {
      return (
        <>
          <TopBar />
          <Navbar />
          <RouterView />
        </>
      );
    };
  },
});
